import { BCollapse } from './collapse';
import { VBToggle } from '../../directives/toggle/toggle';
import { pluginFactory } from '../../utils/plugins';
var CollapsePlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BCollapse: BCollapse
  },
  directives: {
    VBToggle: VBToggle
  }
});
export { CollapsePlugin, BCollapse };
export default CollapsePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/collapse/index.js
// module id = krZB
// module chunks = 21